// © Microsoft Corporation. All rights reserved.

/**
 * Card sizes based on a 300W * 50H virtual grid with zero gutter
 */
export enum CardSizes {
    /** value when no cards sizes are supported/configured */
    None = 0,

    /** Prime legacy 1u card */
    Size1Wx2H = 0x00000001,

    /** Spartan legacy half-height card */
    Size1Wx3H = 0x00000002,

    /** Prime legacy 2u card */
    Size1Wx4H = 0x00000004,

    /** Prime legacy 300x250 ad */
    Size1Wx5H = 0x00000008,

    /** Prime legacy 3u card, Spartan legacy full-height card (including 1 SD card) */
    Size1Wx6H = 0x00000010,

    /** Big Image Card 1-wide 2u-high in Unified Mobile Framework (UMF) design for 1 column */
    Size1Wx7H = 0x00000020,

    /** Reserved */
    Size1Wx8H = 0x00000040,

    /** Spartan legacy one-and-a-half-height card */
    Size1Wx9H = 0x00000080,

    /** Reserved */
    Size1Wx10H = 0x00000100,

    /** Spartan legacy double height (2 SD cards) */
    Size1Wx12H = 0x00000200,

    /** Spartan legacy triple height (3 SD cards) */
    Size1Wx18H = 0x00000400,

    /** Minimum CSS Grid Card Size 300x50 */
    Size1Wx1H = 0x00000800,
    // Reserved = 0x00004000,
    // Reserved = 0x00008000,

    /** Prime legacy 2-column banner */
    Size2Wx2H = 0x00010000,

    /** 2-column banner with 3-u height */
    Size2Wx3H = 0x00020000,

    /** Spartan legacy double-wide card (probably Prime info-pane as well) */
    Size2Wx6H = 0x00040000,

    /** Prime Homepage stripe double-wide card */
    Size2Wx8H = 0x00080000,

    /** Partner Widget Experience 2-wide 2u-high */
    Size2Wx12H = 0x00100000,

    /** Partner Widget Experience 2-wide 3u-high */
    Size2Wx18H = 0x00200000,

    /** Prime legacy 3-column banner */
    Size3Wx2H = 0x00400000,

    /** 3-column banner with 3-u height */
    Size3Wx3H = 0x80000000,

    /** Partner Widget Experience 3-wide 1u-high */
    Size3Wx6H = 0x00800000,

    /** Partner Widget Experience 3-wide 2u-high */
    Size3Wx12H = 0x01000000,

    /** Partner Widget Experience 3-wide 3u-high */
    Size3Wx18H = 0x02000000,

    /** 4-column banner */
    Size4Wx2H = 0x04000000,

    /** 4-column banner with 3-u height */
    Size4Wx3H = 0x08000000,

    /** Partner Widget Experience 4-wide 1u-high */
    Size4Wx6H = 0x10000000,

    /** Partner Widget Experience 4-wide 2u-high */
    Size4Wx12H = 0x20000000,

    /** Partner Widget Experience 4-wide 3u-high */
    Size4Wx18H = 0x40000000,

    /** 5-column banner with 3-u height */
    Size5Wx3H = 0x00001000,

    /** 5-column banner with 6-u height */
    Size5Wx6H = 0x00002000
}